import React from 'react';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import image1 from '../../assets/img/dailymed.png';
import image2 from '../../assets/img/nndss.png';
import image3 from '../../assets/img/clinical_trials.png';
import { CardMedia } from '@mui/material';

const Explorers: React.FC = () => {
    const cardData = [
        {
            href: 'https://dailymed.acoer.com',
            imageSrc: image1,
            title: 'DailyMed Explorer',
            description:
                'Our Drug Database Explorer consumes the DailyMed Drug Database provided by the U.S. National Library of Medicine and transforms the data into a visual dashboard. This ensures a cleaner and more informative user experience, with drill-down filtering on specific drug information, manufacturers, active ingredients, FDA approval status, and more.',
        },
        {
            href: 'https://disease-explorer.acoer.com/',
            imageSrc: image2,
            title: 'Notifiable Disease Explorer',
            description:
                'Our Disease Explorer consumes open notifiable infectious disease data from the National Notifiable Diseases Surveillance System provided by the CDC found at cdc.gov/nndss and transforms the data into a visual dashboard for a cleaner and more informative user experience with drill-down filtering on specific diseases, locations, counts and dates.',
        },
        {
            href: 'https://clinicaltrials.acoer.com',
            imageSrc: image3,
            title: 'Clinical Trials Explorer',
            description:
                'Our Clinical Trials Explorer consumes open clinical trial data provided by the Federal government found at clinicaltrials.gov and transforms the data into a visual dashboard for a cleaner and more informative user experience with drill-down filtering on specific conditions, locations, dates, status, FDA regulated drugs and devices and more.',
        },
    ];

    return (
        <Grid container justifyContent="space-evenly" spacing={3}>
            {cardData.map((data, index) => (
                <Grid item key={index} md={4} xs={11}>
                    <a
                        href={data.href}
                        target="_blank"
                        rel="noreferrer"
                        style={{ textDecoration: 'none' }}
                    >
                        <Card elevation={0}>
                            <CardActionArea>
                                <CardMedia
                                    component="img"
                                    height="140"
                                    image={data.imageSrc}
                                    alt="green iguana"
                                />
                                <CardContent>
                                    <Typography
                                        gutterBottom
                                        variant="h5"
                                        component="div"
                                        color={'primary'}
                                        sx={{ fontWeight: 'bold' }}
                                    >
                                        {data.title}
                                    </Typography>
                                    <Typography
                                        variant="body2"
                                        color="text.secondary"
                                    >
                                        {data.description}
                                    </Typography>
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    </a>
                </Grid>
            ))}
        </Grid>
    );
};

export default Explorers;
